import { getApiBaseUrl } from '../config/apiConfig';
import apiService from './apiService';

const PREFIX = '/depots';
const POLL_INTERVAL_MS = 30000;

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

const depotService = {
  POLL_INTERVAL_MS,

  async listClientsDrive({ rafraichir = false } = {}) {
    const params = {};
    if (rafraichir) {
      params.rafraichir = 1;
    }
    const data = await request(apiService.get(`${PREFIX}/clients-drive`, params));
    return {
      clients: Array.isArray(data.clients) ? data.clients : [],
      from_cache: Boolean(data.from_cache),
      stale: Boolean(data.stale),
    };
  },

  async createClientDrive(nom) {
    const data = await request(apiService.post(`${PREFIX}/clients-drive`, { nom }));
    return data.client;
  },

  async listDestinations() {
    const data = await request(apiService.get(`${PREFIX}/destinations-dossier`));
    return Array.isArray(data.destinations) ? data.destinations : [];
  },

  async listPersonnes() {
    const data = await request(apiService.get(`${PREFIX}/personnes`));
    return Array.isArray(data.personnes) ? data.personnes : [];
  },

  async suggestCommercial(clientFolderId) {
    const params = {};
    if (clientFolderId) {
      params.client_folder_id = clientFolderId;
    }
    const data = await request(apiService.get(`${PREFIX}/commercial-suggere`, params));
    return {
      commercial_id: data.commercial_id ?? null,
      commercial_nom: data.commercial_nom ?? null,
      source: data.source ?? null,
    };
  },

  async listDepots({ page = 1, limit = 20, tous = false } = {}) {
    const params = { page, limit };
    if (tous) {
      params.tous = 1;
    }
    return request(apiService.get(PREFIX, params));
  },

  async getPendingCount() {
    return request(apiService.get(PREFIX, { count_only: 1 }));
  },

  uploadDepot(formData, onProgress) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const token = localStorage.getItem('auth_token') || localStorage.getItem('jwt_token');

      xhr.open('POST', `${getApiBaseUrl()}${PREFIX}`);
      if (token) {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      }

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && typeof onProgress === 'function') {
          onProgress(Math.round((event.loaded / event.total) * 100));
        }
      };

      xhr.onload = () => {
        let data = {};
        try {
          data = JSON.parse(xhr.responseText || '{}');
        } catch {
          data = {};
        }

        if (xhr.status >= 200 && xhr.status < 300 && data.success) {
          resolve(data.data);
          return;
        }

        reject(new Error(data.message || `Erreur upload (HTTP ${xhr.status})`));
      };

      xhr.onerror = () => reject(new Error('Erreur réseau lors de l\'upload'));
      xhr.onabort = () => reject(new Error('Upload annulé'));
      xhr.send(formData);
    });
  },

  async relancer(depotId) {
    return request(apiService.post(`${PREFIX}/${depotId}/relancer`));
  },

  async valider(depotId) {
    return request(apiService.post(`${PREFIX}/${depotId}/valider`));
  },

  async lancerBebedc(depotId) {
    return request(apiService.post(`${PREFIX}/${depotId}/bebedc`));
  },

  async deleteDepot(depotId) {
    return request(apiService.delete(`${PREFIX}/${depotId}`));
  },
};

export default depotService;
